<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card card-primary">
                    
                    <form [formGroup]="addBikeOptionForm" (ngSubmit)="addBike()">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="class_name">Bike Name <span class="required"></span></label>
                                        <input type="text" class="form-control" formControlName="bike_name"
                                            placeholder="Bike Name">
                                    </div>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-3 d-flex justify-content-center align-items-center">
                                    <div class="form-group">
                                        <input class="form-check-input" type="radio" id="solo-bike" value="solo" formControlName="bike_opt">
                                        <label for="solo-bike">
                                            Solo Bike
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-3 d-flex justify-content-center align-items-center">
                                    <div class="form-group">
                                        <input class="form-check-input" type="radio" id="shared-bike" value="shared" formControlName="bike_opt">
                                        <label for="shared-bike">
                                          Shared Bike
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" style="margin-top: -42px;">
                            <div class="row">
                                <div class="col-md-4">

                                    <div class="custom-control custom-checkbox">
                                        <input id="male" type="checkbox" class="custom-control-input"
                                            formControlName="status"
                                            (change)="addBikeOptionForm.get('status').setValue($event.target.checked ? 'active' : 'inactive')"
                                            [checked]="addBikeOptionForm.value.status == 'active'" />
                                        <label class="custom-control-label" for="male">Status</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-footer text-right">
                            <button type="submit" class="btn btn-info">Submit</button>

                            <button type="button" [disabled]="isAuthDisabled" class="btn btn-secondary ml-2"
                                [routerLink]="['/bike-options-list']">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>